/* eslint react-hooks/exhaustive-deps: "warn" */
import { type ReactNode } from 'react';

import cn from 'classnames';

import { Icon } from 'ui/atoms/Icon/Icon';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import { BrandLogo } from 'landing-pages/compare/BrandLogo';

import styles from './CompareFeatures.module.scss';

import type { CompareFeatureItem, CompareLogo } from '../../Compare.types';

type Props = {
  id?: string;
  title: ReactNode;
  description: ReactNode;
  gd: CompareFeatureItem[];
  them: CompareFeatureItem[];
  competitorHeader: string;
  competitorLogo?: CompareLogo;
  background?: string;
};

const FeatureItem = ({ item }: { item: CompareFeatureItem }) => (
  <div className={styles.item}>
    <b className={styles.itemTitle}>
      {item.title}
      {item.badge && <span className={styles.badge}>{item.badge}</span>}
    </b>
    <span className={styles.itemText}>{item.text}</span>
  </div>
);

export const CompareFeatures = ({
  id,
  title,
  description,
  gd,
  them,
  competitorHeader,
  competitorLogo,
  background,
}: Props) => (
  <Section id={id} background={background} className={styles.section}>
    <div className={styles.head}>
      <TitleBlock align="left" className={styles.titleBlock} title={title} description={description} />
    </div>

    <div className={styles.grid}>
      <div className={cn(styles.col, styles.colGd)}>
        <h3 className={cn(styles.colTitle, styles.colTitleBrand)}>
          <BrandLogo className={styles.brandLogo} />
        </h3>
        {gd.map((item, i) => (
          <FeatureItem key={i} item={item} />
        ))}
      </div>

      <div className={styles.col}>
        <h3 className={cn(styles.colTitle, competitorLogo && styles.colTitleBrand)}>
          {competitorLogo ? (
            <span className={styles.competitorLogoChip}>
              <Icon type={competitorLogo.type} className={styles.competitorLogo} />
              <span className={styles.srOnly}>{competitorLogo.label}</span>
            </span>
          ) : (
            competitorHeader
          )}
        </h3>
        {them.map((item, i) => (
          <FeatureItem key={i} item={item} />
        ))}
      </div>
    </div>
  </Section>
);
